import { getBearerAuthHeaders } from "@/lib/authSession";
import { fetchWithAuthRetry } from "@/lib/authedRequest";
import { getInboxAgentWorkspaceId, inboxWorkspaceHeaders } from "@/lib/inboxLiveConfig";

function _resolveWorkspaceId(workspaceId) {
  if (workspaceId && String(workspaceId).trim()) return String(workspaceId).trim();
  return getInboxAgentWorkspaceId();
}

async function _historyFetch(path, { method = "GET", body, workspaceId } = {}) {
  const resolvedWorkspaceId = _resolveWorkspaceId(workspaceId);
  const buildRequest = () => {
    const url = new URL(path, (import.meta.env?.VITE_API_BASE_URL || window.location.origin));
    return fetch(url.toString(), {
      method,
      credentials: "include",
      headers: {
        Accept: "application/json",
        ...getBearerAuthHeaders(),
        ...inboxWorkspaceHeaders(resolvedWorkspaceId),
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
  };
  const res = await fetchWithAuthRetry(buildRequest);
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const j = await res.json();
      if (j?.detail) detail = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
      if (j?.error) detail = j.error;
    } catch {
      /* ignore */
    }
    const err = new Error(detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

export async function fetchTicketCustomerHistory({ ticketId, workspaceId }) {
  return _historyFetch(`/api/v1/agent/tickets/${encodeURIComponent(ticketId)}/customer-history`, { workspaceId });
}

export async function triggerTicketHistorySummary({ ticketId, workspaceId, forceRefresh = false }) {
  return _historyFetch(`/api/v1/agent/tickets/${encodeURIComponent(ticketId)}/customer-history/summary`, {
    method: "POST",
    workspaceId,
    body: { force_refresh: Boolean(forceRefresh) },
  });
}

export async function fetchTicketHistorySummaryStatus({ ticketId, workspaceId }) {
  return _historyFetch(`/api/v1/agent/tickets/${encodeURIComponent(ticketId)}/customer-history/summary-status`, {
    workspaceId,
  });
}

export async function fetchTicketThreadMessages({ ticketId, workspaceId }) {
  return _historyFetch(`/api/v1/agent/tickets/${encodeURIComponent(ticketId)}/messages`, { workspaceId });
}
